module.exports = __webpack_public_path__ + "img/多项目.0e03bfdc.png";